import { gql } from "@apollo/client";

export const SEND_OTP = gql`
	mutation SEND_OTP($email: String!) {
		response: sendOTPViaEmail(email: $email) {
			statusCode
			message
		}
	}
`;

export const LOGIN = gql`
	mutation LOGIN($email: String!, $password: String!, $code: Int!) {
		response: adminLogin(email: $email, password: $password, code: $code) {
			statusCode
			message
			token
		}
	}
`;

export const LOGOUT = gql`
	mutation LOGOUT {
		response: adminLogout {
			statusCode
			message
		}
	}
`;
